import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import ManifestDetails from './manifest/Manifest_details';
import ContainerDetails from './manifest/Container_details';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Manifest = () => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('exportbl');
    const [bLNumber, setBLNumber] = useState('');
    const [data, setData] = useState(undefined);
    const [placeofDelivery, setPlaceofDelivery] = useState('');
    const [masterBL, setMasterBL] = useState('');
    const [houseBL, sethouseBL] = useState('');
    const [blDate, setBLDate] = useState('');
    const [vesCode, setvesCode] = useState('');
    const [vesDesc, setVesDesc] = useState('');
    const [voyCode, setVoyCode] = useState('');
    const [voyDesc, setVoyDesc] = useState('');
    const [polCode, setPolCode] = useState('');
    const [polDesc, setPolDesc] = useState('');
    const [podCode, setPodCode] = useState('');
    const [podDesc, setPodDesc] = useState('');



    const [placeOfReceipt, setPlaceOfReceipt] = useState('');
    const [preCarrageBy, setPreCarrageBy] = useState('');
    const [finalDestination, setFinalDestination] = useState('');
    const [grossWeight, setGrossWeight] = useState('');
    const [noOfCont, setNoOfCont] = useState('');
    const [mesurement, setMesurement] = useState('');
    const [noOfContInWords, setNoOfContInWords] = useState('');
    const [shipper, setshipper] = useState('');
    const [consignee, setConsignee] = useState('');
    const [notyfyParty, setNotyfyParty] = useState('');
    const [deliverGoods, setDeliverGoods] = useState('');


    const [marksNumbers, setMarksNumbers] = useState('');
    const [packageDesc, setPackageDesc] = useState('');
    const [freightChargers, setFreightChargers] = useState('');
    const [revenueTons, setRevenueTons] = useState('');
    const [rate, setRate] = useState('');
    const [per, setPer] = useState('');
    const [prepaid, setPrepaid] = useState('');
    const [collect, setCollect] = useState('');
    const [exchageRate, setExchageRate] = useState('');
    const [prepaidAt, setPrepaidAt] = useState('');
    const [paybleAt, setPaybleAt] = useState('');
    const [totPaidNatCurrency, setTotPaidNatCurrency] = useState('');
    const [placeDateIssue, setPlaceDateIssue] = useState('');
    const [noOfOrgBls, setNoOfOrgBls] = useState('');

    const [addDesc, setaddDesc] = useState('');
    

    


    const hadlePlaceofDelivery = (value) => {
        setPlaceofDelivery(value);
    }
    const hadleMasterBL = (value) => {
        setMasterBL(value);
    }
    const hadleHouseBL = (value) => {
        sethouseBL(value);
    }
    const hadleBLDate = (value) => {
        setBLDate(value);
    }

    const hadleVesCode = (value) => {
        setvesCode(value);
    }

    const hadleVesDesc = (value) => {
        setVesDesc(value);
    }
    const hadlevoyCode = (value) => {
        setVoyCode(value);
       
    }
    const hadleVoyDesc = (value) => {
        setVoyDesc(value); 

    }
    const hadlePolCode = (value) => {
        setPolCode(value); 

    }
    const hadlePolDesc = (value) => {
        setPolDesc(value); 

    }
    const hadlepodCode = (value) => {
        setPodCode(value); 

    }
    const hadlepodDesc = (value) => {
        setPodDesc(value); 

    }

    const hadlePlaceOfReceipt = (value) => {
        setPlaceOfReceipt(value);
    }
    const hadlePreCarrageBy = (value) => {
        setPreCarrageBy(value);
    }
    const hadleFinalDestination = (value) => {
        setFinalDestination(value);
    }
    const hadleGrossWeight = (value) => {
        setGrossWeight(value);
    }
    const hadleNoOfCont = (value) => {
        setNoOfCont(value);
    }
    const hadleMesurement = (value) => {
        setMesurement(value);
    }
    const hadleNoOfContInWords = (value) => {
        setNoOfContInWords(value);
    }
    const hadleShipper = (value) => {
        setshipper(value);
    }
    const hadleConsignee = (value) => {
        setConsignee(value);
    }
    const hadleNotyfyParty = (value) => {
        setNotyfyParty(value);
    }
    const hadleDeliverGoods = (value) => {
        setDeliverGoods(value);
    }
    const hadleMarksNumbers = (value) => {
        setMarksNumbers(value);
    }
    const hadlePackageDesc = (value) => {
        setPackageDesc(value);
    }
    const hadleFreightChargers = (value) => {
        setFreightChargers(value);
    }
    const hadleRevenueTons = (value) => {
        setRevenueTons(value);
    }
    const hadleRate = (value) => {
        setRate(value);
    }
    const hadlePer = (value) => {
        setPer(value);
    }
    const hadlePrepaid = (value) => {
        setPrepaid(value);
    }
    const hadleCollect = (value) => {
        setCollect(value);
    }
    const hadleExchageRate = (value) => {
        setExchageRate(value);
    }
    const hadlePrepaidAt = (value) => {
        setPrepaidAt(value);
    }
    const hadlePaybleAt = (value) => {
        setPaybleAt(value);
    }
    const hadleTotPaidNatCurrency = (value) => {
        setTotPaidNatCurrency(value);
    }
    const hadlePlaceDateIssue = (value) => {
        setPlaceDateIssue(value);
    }
    const hadleNoOfOrgBls = (value) => {
        setNoOfOrgBls(value);
    }
    const hadleAddDesc = (value) => {
        setaddDesc(value);
    }



    const handleBLNunber = (bLNum) => {
        setBLNumber(bLNum);
       
        if( bLNum !== ''){
            fetch(`${baseUrl}${pageComponent}/show/${bLNum}`)
            .then(response => response.json())
            .then(data => {
                setData(data.expbl);
            })
        }
        
    }

    const handleContainerCUS = () => {
        // const inputExBL = {MasterBLNo :masterBL, HouseBLNo : houseBL, BLDate: blDate, VesCode: vesCode, VesDesc: vesDesc, VoyCode:voyCode, VoyDesc: voyDesc, PODCode: podCode, PODDesc:podDesc, POLCode: polCode, POLDesc: polDesc, PlaceOfDelivery: placeofDelivery,
        //     PlaceOfReceipt: placeOfReceipt, PreCarrageBy: preCarrageBy, Shipper: shipper, Consignee: consignee, NotyfyParty: notyfyParty, DeliverGoods: deliverGoods, FinalDestination: finalDestination, GrossWeight:grossWeight, Mesurement: mesurement, MarksNumbers: marksNumbers, PackageDesc:packageDesc, FreightChargers: freightChargers, RevenueTons: revenueTons, Rate: rate, Per: per, 
        //     Prepaid: prepaid, Collect: collect, ExchageRate: exchageRate, PrepaidAt: prepaidAt, PaybleAt: paybleAt, TotPaidNatCurrency: totPaidNatCurrency, PlaceDateIssue: placeDateIssue, AddDesc: addDesc, NoOfOrgBls: noOfOrgBls, NoOfCont: noOfCont, NoOfContInWords: noOfContInWords,};

        const inputExBL = {MasterBLNo :masterBL, BLDate: blDate, VesCode: vesCode, VesDesc: vesDesc, VoyCode:voyCode, VoyDesc: voyDesc, PODCode: podCode, PODDesc:podDesc, POLCode: polCode, POLDesc: polDesc, PlaceOfDelivery: placeofDelivery,
            PlaceOfReceipt: placeOfReceipt, PreCarrageBy: preCarrageBy, Shipper: shipper, Consignee: consignee, NotyfyParty: notyfyParty, DeliverGoods: deliverGoods, FinalDestination: finalDestination, GrossWeight:grossWeight, Mesurement: mesurement, MarksNumbers: marksNumbers, PackageDesc:packageDesc, FreightChargers: freightChargers, RevenueTons: revenueTons, Rate: rate, Per: per, 
            Prepaid: prepaid, Collect: collect, ExchageRate: exchageRate, PrepaidAt: prepaidAt, PaybleAt: paybleAt, TotPaidNatCurrency: totPaidNatCurrency, PlaceDateIssue: placeDateIssue, AddDesc: addDesc, NoOfOrgBls: noOfOrgBls, NoOfCont: noOfCont, NoOfContInWords: noOfContInWords,};
        axios.post(`http://mol.evolve-demo.com/api/exportbl/store`, inputExBL)
            .then(response => {
                window.location.reload(false);
                alert('Successfully Save Data');
            })
            .catch(error => {
                console.error(error);
                alert(error);
            });
    };




    return (
        <Container>
           
            <ToastContainer autoClose={2000} />
            <Tabs
                defaultActiveKey="home"
                id="justify-tab-example"
                className="mb-3 mt-3 pt-2"
                justify
            >
                <Tab eventKey="home" title="Manifest Details">
                    <ManifestDetails 
                    onhandleBLNunber={handleBLNunber} 
                    onhadlePlaceofDelivery={hadlePlaceofDelivery}
                    onhadleMasterBL={hadleMasterBL}
                    onhadleHouseBL={hadleHouseBL}
                    onhadleBLDate={hadleBLDate}
                    onhadleVesCode={hadleVesCode}
                    onhadleVesDesc={hadleVesDesc}
                    onhadlevoyCode={hadlevoyCode}
                    onhadleVoyDesc={hadleVoyDesc}
                    onhadlePolCode={hadlePolCode}
                    onhadlePolDesc={hadlePolDesc}
                    onhadlepodCode={hadlepodCode}
                    onhadlepodDesc={hadlepodDesc}
                    onhadlePlaceOfReceipt={hadlePlaceOfReceipt}
                    onhadlePreCarrageBy={hadlePreCarrageBy}
                    onhadleFinalDestination = {hadleFinalDestination}
                    onhadleGrossWeight ={hadleGrossWeight}
                    onhadleNoOfCont = {hadleNoOfCont}
                    onhadleMesurement = {hadleMesurement}
                    onhadleNoOfContInWords={hadleNoOfContInWords}
                    onhadleShipper={hadleShipper}
                    onhadleConsignee={hadleConsignee}
                    onhadleNotyfyParty={hadleNotyfyParty}
                    onhadleDeliverGoods={hadleDeliverGoods}
                    />
                </Tab>
                <Tab eventKey="profile" title="Container Details">
                    <ContainerDetails 
                    data={data} 
                    bLNumber={bLNumber}
                    onhadleMarksNumbers={hadleMarksNumbers}
                    onhadlePackageDesc={hadlePackageDesc}
                    onhadleFreightChargers={hadleFreightChargers}
                    onhadleRevenueTons={hadleRevenueTons}
                    onhadleRate={hadleRate}
                    onhadlePer={hadlePer}
                    onhadlePrepaid={hadlePrepaid}
                    onhadleCollect={hadleCollect}
                    onhadleExchageRate={hadleExchageRate}
                    onhadlePrepaidAt={hadlePrepaidAt}
                    onhadlePaybleAt={hadlePaybleAt}
                    onhadleTotPaidNatCurrency={hadleTotPaidNatCurrency}
                    onhadlePlaceDateIssue={hadlePlaceDateIssue}
                    onhadleNoOfOrgBls={hadleNoOfOrgBls}
                    
                    />
                </Tab>
                
            </Tabs>
            <Row>
                <Col>
                    <Form className='mt-4 bottom-border pb-3' >
                        <Row className='text-center'>
                            <Col className='text-end'>
                                <Button className="ms-3" variant="primary" onClick={handleContainerCUS}>
                                    Save
                                </Button>

                                <Button className="ms-3" variant="primary" >
                                    New
                                </Button>

                                <Button className="ms-3" variant="primary">
                                    Update
                                </Button>
                                <Button className="ms-3" variant="primary">
                                    Delete
                                </Button>

                                <Button className="ms-3" variant="primary">
                                    Print
                                </Button>

                                <Button className="ms-3" variant="primary" type="submit">
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>

    );

}

export default Manifest;

